import { type FC } from 'react';
import cn from 'classnames';

import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';

import { SpecContractBenefit } from '../AboutSpecContract/SpecContractBenefit';

import { benefitByKind } from './config';

interface ContractBenefitsProps {
  kind: SpecContractType | PaidSpecContractType;
  className?: string;
}

const ContractBenefits: FC<ContractBenefitsProps> = ({ kind, className }) => {
  const list = benefitByKind[kind];

  return (
    <div className={cn('flex flex-col gap-1 px-8 w-full', className)}>
      {list.map(({ id, ...props }) => (
        <SpecContractBenefit key={id} {...props} />
      ))}
    </div>
  );
};

export { ContractBenefits };
